module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ThinItalic-5793149e6a34a97d9be09f07cb63a0e9.woff2";